<template lang="pug">
#eventsSorting.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='langLabel' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header
        .icon(data-bs-dismiss='modal' aria-label='Close')
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.default_event_sorting") }}
      .modal-body
        ul.list-group.setting
          template(v-for="(item,index) in eventSorting")
            li.list-group-item(:class="{active: defaultEventSorting == index+1}" @click="setDefaultEventSorting(index+1)")
              span {{ $t(item) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data: () => ({
    eventSorting: ["ui.normal_sorting", "ui.sort_by_time"]
  }),
  computed: {
    defaultEventSorting() {
      return this.$store.getters.pageDisplay.eventSorting;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
  },
  methods: {
    setDefaultEventSorting(s) {
      // this.$store.dispatch("layout/setSinglePageDisplay", {property: "eventSorting", value: s.toString()});
      // EventBus.$emit("DEFAULT_EVENT_SORTING");
      // $('#eventsSorting').modal('hide');

      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify({
            language: this.pageDisplay.language,
            oddsType: this.pageDisplay.oddsType,
            pageType: this.pageDisplay.pageType,
            showScoreMap: this.pageDisplay.showScoreMap,
            eventSorting: s.toString(),
            marketType: this.pageDisplay.marketType,
            pageSize: this.pageDisplay.pageSize,
            mmoType: this.pageDisplay.mmoType,
          }),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify({
            defaultStake: this.betting.defaultStake,
            acceptBetterOdds: this.betting.acceptBetterOdds,
            acceptAnyOdds: this.betting.acceptAnyOdds,
            autoRefreshOdds: this.betting.autoRefreshOdds,
            quickBet: this.betting.quickBet,
            defaultStakeAmount: this.betting.defaultStakeAmount,
            quickBetAmount: this.betting.quickBetAmount,
          }),
        })
        .then(
          (res) => {
            this.$store.dispatch("layout/setSinglePageDisplay", {property: "eventSorting", value: s.toString()}).then(
              (res) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
              },
              (err) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
              }
            );
            EventBus.$emit("DEFAULT_EVENT_SORTING");
            $('#eventsSorting').modal('hide');
          },
          (err) => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
            EventBus.$emit("DEFAULT_EVENT_SORTING");
            $('#eventsSorting').modal('hide');
          }
        );
    }
  }
}
</script>